import React from 'react';
import AMW_Logo_Small from '../assets/AMW_Logo_Small.jpg';

export default function AMWLogo({ product, size = 'small' }) {
  return product.appellationMarlborough?.value ? (
    <img src={AMW_Logo_Small} style={{ height: 30, marginRight: '16px' }} />
  ) : null;
}
